import { useRef, useState } from 'react';
import { useDidUpdate } from '@lt/components/hooks';

export const useEmailWasChanged = () => {
  const [emailWasChanged, setEmailWasChanged] = useState(false);

  const emailWasChangedRef = useRef<boolean>(false);

  useDidUpdate(() => {
    emailWasChangedRef.current = emailWasChanged;
  }, [emailWasChanged]);

  return {
    emailWasChanged,
    emailWasChangedRef,
    setEmailWasChanged,
  };
};
